import { disallowedKeywords } from './constants';

const validateRedirectURI = (path) => {
  const pattern = `(${disallowedKeywords.join('|')})`;
  const regex = new RegExp(pattern);
  if (regex.test(path)) {
    return false;
  }
  return true;
};

export const clearParams = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('expires_in');
  document.cookie.split(';').forEach(cookie => { document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`); });
};

export default validateRedirectURI;